import { FeatureAppConfig } from '../types/service-configs';
import { ModelOverviewIntegratorOptions } from './create-options-from-query-params';

// Use for testing the SSR locally, make sure to set to false when not testing
const isLocalSSR = false;

export const graphQLServerUrl = 'https://qa.vwquickstartguidegqlservice.svc.vwusa.io/graphql'; //'http://localhost:3002/graphql';
export const ssrServerUrl = isLocalSSR ? 'http://localhost:5000' : '';
export const publishEndpointUrl =
  'https://publish-p122604-e1205289.adobeaemcloud.com/graphql/execute.json/nar';

export const defaultAppConfig = {
  appsUMD: '/assets/quick-start-guide/quick-start-guide-umd.js',
  appsCommonsJS: `${ssrServerUrl}/assets/quick-start-guide/quick-start-guide-commonjs.js`,
  appContent: null,
  ssrServerUrl,
  graphQLServerUrl,
  publishEndpointUrl,
  useLoggerFeatureService: true,
};

export function createQSGConfig({
  mode,
  faServicesUrl,
}: ModelOverviewIntegratorOptions): FeatureAppConfig & any {
  return {
    ...defaultAppConfig,
    mode,
    faServicesUrl,
  };
}
